"use strict";

angular
    .module('rmEPG')
    .factory('server', ['$http', function ($http) {

    var serverDiff = 0;

    $http.get('/time.json').then((request) => {

        let U = request.data * 1000;

        serverDiff = Date.now() - U;
    });

    return {
        now () {

            return Date.now() - serverDiff;
        }
    };
}]);
